"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chunk_1 = __importDefault(require("lodash/chunk"));
var react_1 = __importDefault(require("react"));
var config_1 = require("../config");
var cols = function (props) {
    var b = config_1.block("columns");
    var columns = props.columns, byColumns = props.byColumns, className = props.className, children = props.children, firstColumnLimit = props.firstColumnLimit;
    var countOfColumns = columns || 2;
    var childrens = react_1.default.Children.toArray(children);
    var renderChildByChild = function () {
        return childrens.map(function (item, index) { return (react_1.default.createElement("div", { key: "col-" + index, className: b("col").mix("col-md-" + 12 / countOfColumns) }, item)); });
    };
    var renderByColumns = function () {
        var total = childrens.length;
        var chunkLength = Math.ceil(total / countOfColumns);
        var chunks;
        if (countOfColumns === 3 && total % 3 === 1) {
            var firstColumn_1 = [];
            var secondColumn_1 = [];
            var thirdColumn_1 = [];
            chunks = [firstColumn_1, secondColumn_1, thirdColumn_1];
            childrens.forEach(function (item, index) {
                if (index < Math.ceil(total / countOfColumns)) {
                    firstColumn_1.push(item);
                }
                else if (index <= 2 * Math.floor(total / countOfColumns)) {
                    secondColumn_1.push(item);
                }
                else {
                    thirdColumn_1.push(item);
                }
            });
        }
        else if (firstColumnLimit) {
            var firstColumn = childrens.slice(0, firstColumnLimit);
            var secondColumn = childrens.slice(firstColumnLimit);
            chunks = [firstColumn, secondColumn];
        }
        else {
            chunks = chunk_1.default(childrens, chunkLength);
        }
        return chunks.map(function (items, index) { return (react_1.default.createElement("div", { key: "col-" + index, className: b("col").mix("col-md-" + 12 / countOfColumns) }, items)); });
    };
    return (react_1.default.createElement("div", { className: b({ cols: countOfColumns }).mix(className) },
        react_1.default.createElement("div", { className: b("container").mix("row") }, byColumns ? renderByColumns() : renderChildByChild())));
};
exports.default = cols;
//# sourceMappingURL=index.js.map